<div id="loaderAnim" style="background-color:rgba(0,0,0,0.5);position:fixed;z-index:2001;display:none;top:0px;text-align:center;width:100%;height:100%">
    <!-- to resize simply adjust width and height in tag svg -->
    <svg style="top:230px;position:relative;" width="120px" height="120px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="uil-default">
        <rect x="0" y="0" width="100" height="100" fill="none" class="bk"></rect>
        <rect x="46.5" y="40" width="7" height="20" rx="5" ry="5" fill="#F08100" transform="rotate(0 50 50) translate(0 -30)">
            <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0s" repeatCount="indefinite"></animate>
        </rect>
        <rect x="46.5" y="40" width="7" height="20" rx="5" ry="5" fill="#F08100" transform="rotate(30 50 50) translate(0 -30)">
            <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0.08333333333333333s" repeatCount="indefinite"></animate>
        </rect>
        <rect x="46.5" y="40" width="7" height="20" rx="5" ry="5" fill="#F08100" transform="rotate(60 50 50) translate(0 -30)">
            <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0.16666666666666666s" repeatCount="indefinite"></animate>
        </rect>
        <rect x="46.5" y="40" width="7" height="20" rx="5" ry="5" fill="#F08100" transform="rotate(90 50 50) translate(0 -30)">
            <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0.25s" repeatCount="indefinite"></animate>
        </rect>
        <rect x="46.5" y="40" width="7" height="20" rx="5" ry="5" fill="#F08100" transform="rotate(120 50 50) translate(0 -30)">
            <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0.3333333333333333s" repeatCount="indefinite"></animate>
        </rect>
        <rect x="46.5" y="40" width="7" height="20" rx="5" ry="5" fill="#F08100" transform="rotate(150 50 50) translate(0 -30)">
            <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0.4166666666666667s" repeatCount="indefinite"></animate>
        </rect>
        <rect x="46.5" y="40" width="7" height="20" rx="5" ry="5" fill="#F08100" transform="rotate(180 50 50) translate(0 -30)">
            <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0.5s" repeatCount="indefinite"></animate>
        </rect>
        <rect x="46.5" y="40" width="7" height="20" rx="5" ry="5" fill="#F08100" transform="rotate(210 50 50) translate(0 -30)">
            <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0.5833333333333334s" repeatCount="indefinite"></animate>
        </rect>
        <rect x="46.5" y="40" width="7" height="20" rx="5" ry="5" fill="#F08100" transform="rotate(240 50 50) translate(0 -30)">
            <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0.6666666666666666s" repeatCount="indefinite"></animate>
        </rect>
        <rect x="46.5" y="40" width="7" height="20" rx="5" ry="5" fill="#F08100" transform="rotate(270 50 50) translate(0 -30)">
            <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0.75s" repeatCount="indefinite"></animate>
        </rect>
        <rect x="46.5" y="40" width="7" height="20" rx="5" ry="5" fill="#F08100" transform="rotate(300 50 50) translate(0 -30)">
            <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0.8333333333333334s" repeatCount="indefinite"></animate>
        </rect>
        <rect x="46.5" y="40" width="7" height="20" rx="5" ry="5" fill="#F08100" transform="rotate(330 50 50) translate(0 -30)">
            <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0.9166666666666666s" repeatCount="indefinite"></animate>
        </rect>
    </svg>
</div>
<elem-error></elem-error>
<elem-message></elem-message>
<elem-confirm></elem-confirm>
<div class="app-content" [class.loggedIn]="loggedIn">
    @if (keycloakError) {
        <div>Zurzeit gibt es ein technisches Problem mit dem Login-Provider. Bitte versuchen Sie es später noch einmal.</div>
    }
    <router-outlet></router-outlet>
</div>
